<script>
  import { createEventDispatcher } from 'svelte';
  import { selectedGroup } from '../store';
  import http from '../api/http.js';
  import { Modal, ModalBody, ModalFooter, ModalHeader } from 'sveltestrap';


  let shown =false;
  let credentialId;
  let credentialName;
  const dispatch = createEventDispatcher();


  export async function show(selectedCredential) {
    selectedCredential = selectedCredential;
    credentialId = selectedCredential.id;
    credentialName = selectedCredential.name;
    shown = true;
  }

  function _onYes() {
    deleteCredential();
    shown = false;
  }

  function _onNo() {
    shown = false;
  }

  async function deleteCredential() {
    const res = await http.delete(window.apiBaseUrl + `/deploy/dashboard/credentials/${credentialId}/${$selectedGroup}`);

    if (res.ok) {
      dispatch('modalClosed');
      shown = false;
    }
  }
</script>

<Modal isOpen={shown}>
  <ModalHeader>
    Delete Credentials
  </ModalHeader>
  <ModalBody>
    <p>Are you sure you want to delete <strong class="text-info">{credentialName}</strong>?</p>
    <p class="text-danger"><i class="fa fa-exclamation-triangle"></i> This action is <strong>Permanent</strong> and cannot be undone are you sure you wish to continue?</p> 
  </ModalBody>
  <ModalFooter>
    <button id="delete-credential-cancel-button" class="btn btn-outline-primary" on:click={() => _onNo()}>Cancel</button>
    <button id="delete-credential-confirm-button" on:click={() => _onYes()} class="btn btn-primary">Confirm</button>
  </ModalFooter>
</Modal>

<style>

</style>